"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

/**
 * The logo of the site that implements this Footer component.
 * This component is optional.
 * @param {Object} logo object containing data about logo
 * @package
 */
var Logo = function Logo(_ref) {
  var url = _ref.url,
      alt = _ref.alt,
      width = _ref.width,
      height = _ref.height,
      title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("img", {
    src: url,
    alt: alt,
    width: width,
    height: height,
    title: title
  });
};

var _default = Logo;
exports["default"] = _default;